import React from 'react'
import { useQueryParam, ArrayParam, StringParam } from 'use-query-params'
import { Modal } from '../../components/Modal'
import { IBaseModalProps } from '../../components/types'
import { SchoolLevelFilter } from '../SchoolsFilter/SchoolLevelFilter'
import { updateAndNavigateByQueryString } from '../../helpers/UtilHelper'
import { SchoolSectorFilter } from '../SchoolsFilter/SchoolSectorFilter'
import { SchoolGenderFilter } from '../SchoolsFilter/SchoolGenderFilter'
import { Button, ButtonThemeType } from '../../components/Button'

const SchoolSearchFilterModal = ({ onCloseClick }: IBaseModalProps) => {
  const [levels] = useQueryParam('levels', ArrayParam)
  const [sector] = useQueryParam('sector', StringParam)
  const [gender] = useQueryParam('gender', StringParam)
  return (
    <Modal
      onCloseClick={onCloseClick}
      header="Search Filter"
      footer={
        <Button
          inline
          theme={ButtonThemeType.PRIMARY}
          onClick={() => onCloseClick()}
        >
          Close
        </Button>
      }
    >
      <SchoolLevelFilter
        labelHeader="Level"
        value={levels || []}
        isCollapsible={false}
        onChange={(value) => {
          updateAndNavigateByQueryString({
            levels: value,
          })
        }}
      />
      <SchoolSectorFilter
        labelHeader="Sector"
        value={sector}
        isCollapsible={false}
        onChange={(value) => {
          updateAndNavigateByQueryString({
            sector: value,
          })
        }}
      />
      <SchoolGenderFilter
        labelHeader="Gender"
        value={gender}
        isCollapsible={false}
        onChange={(value) => {
          updateAndNavigateByQueryString({
            gender: value,
          })
        }}
      />
    </Modal>
  )
}

export default SchoolSearchFilterModal
